import React from 'react'

import { Box, Tooltip } from '@mui/material'

type AuditTextProps = {
  text?: string
}

const AuditText = ({ text }: AuditTextProps) => (
  <Tooltip title={text}>
    <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</Box>
  </Tooltip>
)

export default AuditText
